'use client'
import { Avatar as ChakraAvatar } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { AvatarProps } from './Avatar.types'

export default forwardRef(function Avatar(
  props: AvatarProps,
  ref: LegacyRef<HTMLSpanElement>
) {
  return <ChakraAvatar {...props} ref={ref} translate="no" />
})
